/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */
import React from "react";
import { useTheme } from "../../theme/ThemeContext";

/**
 * Pill/checkbox multi-select for column names.
 * Props:
 *   selected         — array of column-name strings
 *   onToggle         — (colName) => void
 *   availableColumns — array of { name, data_type }
 *   disabled         — boolean (read-only render)
 */
export default function FieldPillPicker({ selected = [], onToggle, availableColumns = [], disabled = false }) {
  const { theme } = useTheme();
  if (availableColumns.length === 0) {
    return <span style={{ fontSize: 12, color: "#aaa" }}>No columns available yet.</span>;
  }
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "6px 14px" }}>
      {availableColumns.map(col => {
        const checked = selected.includes(col.name);
        return (
          <label key={col.name} style={{
            display: "flex", alignItems: "center", gap: 5,
            cursor: disabled ? "default" : "pointer", fontSize: 13,
            padding: "3px 8px", borderRadius: 6,
            border: `1px solid ${checked ? theme.primary : (theme.borderColor || "#dee2e6")}`,
            background: checked ? `${theme.primary}18` : "#fff",
            color: checked ? theme.primary : "#333", userSelect: "none",
            opacity: disabled ? 0.6 : 1,
          }}>
            <input
              type="checkbox"
              checked={checked}
              disabled={disabled}
              onChange={() => !disabled && onToggle(col.name)}
              style={{ accentColor: theme.primary, cursor: disabled ? "default" : "pointer" }}
            />
            {col.name}
            <span style={{ fontSize: 10, color: "#888" }}>({col.data_type})</span>
          </label>
        );
      })}
    </div>
  );
}
